/**
 * @author filatov
 */
import $ from "jquery"
import InvoicePreviewRenderer from './InvoicePreviewRenderer'
import OldBaseFormMediator from './OldBaseFormMediator'
import InvoiceEditFormConfigController from './edit_config_controller/InvoiceEditFormConfigController'

export default function InvoiceFormMediator () {}

InvoiceFormMediator.prototype = new OldBaseFormMediator();

InvoiceFormMediator.prototype.init = function ( config ) {
    OldBaseFormMediator.prototype.init.call(this, config);
    return this;
};


InvoiceFormMediator.prototype.initEditConfigController = function ( config ) {
    return new InvoiceEditFormConfigController().init(
            {
                panelId: "mainContainer",
                reportParameters: config.reportParameters,
                reportAuthorizationInfo: config.reportAuthorizationInfo,
                cpList: config.cpList,
                customersWithMaIds: config.customersWithMaIds,
                projectsWithMaIds: config.projectsWithMaIds,
                changeCallback: () => this.changeParametersCallback(),
            } );
};

InvoiceFormMediator.prototype.initPreviewGeneratorsAndGeneratePreview = function ()  {
    this.invoicePreviewRenderer = new InvoicePreviewRenderer().init();
    this.updatePreview();
};

InvoiceFormMediator.prototype.initButtons = function() {
    $("#applyReportConfiguration").click(() => this.onApply())
    $("#cancelReportConfiguration").click(() => this.onCancel())
};

InvoiceFormMediator.prototype.generatePreviewFnc = function ( reportParameters ) {
    this.invoicePreviewRenderer.updateGrouping(reportParameters);
};


// WEBPACK FOOTER //
// ./web/js/reports/InvoiceFormMediator.js